// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Arrows: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 34 27"
            fill="currentColor"
            width="24"
            height="24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
        >
            <path d="M25.6.7l8.1 7.7c.4.4.4 1 .1 1.4l-.1.1-.6.6c-.4.3-.9.4-1.3.1l-.1-.1-5.4-5.1v20.2c0 .5-.4.9-.9 1h-1c-.5 0-.9-.4-1-.9V5.6l-5.2 5c-.3.3-.8.4-1.2.1v-.2l-.1-.1-.6-.6c-.4-.4-.4-1-.1-1.4l.1-.1 8-7.6c.4-.2.9-.3 1.3 0zM9.5.5c.5 0 .9.4 1 .9v20.1l5.2-5c.3-.3.8-.4 1.2-.1l.1.1.1.1.6.6c.4.4.4 1 .1 1.4l-.1.1-8 7.6c-.4.3-.9.4-1.3.1l-.1-.1-8-7.6c-.4-.4-.4-1-.1-1.4l.1-.1.6-.6c.4-.3.9-.4 1.3-.1l.1.1 5.4 5.1V1.5c0-.5.4-.9.9-1h.9z" />
        </svg>
    );
};

export default React.memo(Arrows);
